var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoungeExpFilled = function SvgLoungeExpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 32,
    fill: "#827127",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.927c0 .277.254.483.53.461q.171-.013.345-.013a4.38 4.38 0 0 1 4.202 3.153.47.47 0 0 0 .443.347h4.71a.47.47 0 0 0 .443-.347 4.38 4.38 0 0 1 4.547-3.14c.276.022.53-.184.53-.46V3.5A3.5 3.5 0 0 0 14 0H5.25a3.5 3.5 0 0 0-3.5 3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.85a2.63 2.63 0 0 0 1.75-2.475V8.75a2.625 2.625 0 0 0-5.25 0v.875H5.25V8.75a2.625 2.625 0 1 0-5.25 0v2.625c0 1.143.73 2.115 1.75 2.476v1.024a.875.875 0 0 0 1.75 0V14h12.25v.875a.875.875 0 0 0 1.75 0z"
  })));
};
export default SvgLoungeExpFilled;